import { Typography } from "@mui/material";
import { OrganisationAvatar } from "components/layout/avatar/OrganisationAvatar";
import { Organisation } from "graphql/generated/types";
import {
    EventCardDetailsSection,
    EventCardDetailsSectionProps,
} from "./EventCardDetailsSection";
import { SportTypeIcon } from "components/routes/root/eventCard/SportTypeIcon";

export type EventCardOrganisationProps = {
    organisation: Pick<Organisation, "name" | "logo" | "sportType">;
    logo?: boolean;
    sportType?: boolean;
} & Omit<EventCardDetailsSectionProps, "children">;

export const EventCardOrganisation: React.FC<EventCardOrganisationProps> = ({
    organisation,
    logo = true,
    sportType,
    ...props
}) => {
    return (
        <EventCardDetailsSection
            data-testid="event-card-organisation"
            {...props}
        >
            {logo && (
                <OrganisationAvatar
                    alt={organisation.name}
                    src={organisation.logo}
                    size="md"
                />
            )}
            <Typography variant="body2" color="text.primary" flexGrow={1}>
                {organisation.name}
            </Typography>
            {sportType && <SportTypeIcon sportType={organisation.sportType} />}
        </EventCardDetailsSection>
    );
};
